/**
 * Sanitizes email HTML by removing or disabling clickable links
 * This prevents users from accidentally clicking tracking/unsubscribe links in previews
 *
 * @param html The HTML content to sanitize
 * @returns Sanitized HTML with links disabled
 */
export const sanitizeEmailHtml = (html: string): string => {
  if (!html) return '';

  // Create a temporary div to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  // Find all anchor tags
  const links = tempDiv.querySelectorAll('a');

  // Remove href attributes or make them non-functional
  links.forEach((link) => {
    // Store the original href in a data attribute for reference
    const href = link.getAttribute('href');
    if (href) {
      link.setAttribute('data-original-href', href);
    }

    // Remove the href to make it non-clickable
    link.removeAttribute('href');

    // Add a style to show it's not clickable
    link.style.cursor = 'default';
    link.style.textDecoration = 'none';
  });

  return tempDiv.innerHTML;
};
